import {useQueryClient} from "react-query";
import _ from "underscore";
import {makeStyles, useTheme, withStyles} from "@material-ui/core/styles";
import {useCostings} from "../../../services/costings";
import {Tooltip} from "@material-ui/core";

const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
});

const CostingUuidLookup = props => {
  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    }
  }))(theme);

  const queryClient = useQueryClient();
  const extraKeys = [];
  const records = useCostings({queryClient, useCache: true, extraKeys});

  if (props.type === "render") {
    const costing = _.find(records.data, {costingUuid: props.value});
    if (props.hideCode) {
      return (
        <Tooltip title={records.data && costing ?`UCN${costing.costingNumber} - ${costing.tripRouting} ${costing.tripRouting ? `part of trip (${costing.tripRouting})` : ""}` : ''}>
          <div>{records.data && costing ? `${costing.route} ${costing.tripRouting ? `part of trip (${costing.tripRouting})` : ""}` :''}</div>
        </Tooltip>
      );
    }
    return (
      <Tooltip title={records.data && costing ?`UCN${costing.costingNumber} - ${costing.tripRouting} ${costing.tripRouting ? `part of trip (${costing.tripRouting})` : ""}` : ''}>
      <div>
          {records.data && costing ?`UCN${costing.costingNumber} - ${costing.tripRouting}` : ''}
      </div>
      </Tooltip>
    );
  }

  return <></>
}

export default withStyles(styles) (CostingUuidLookup);
export {
  CostingUuidLookup
}
